import { Component, inject, OnInit } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { provideIcons } from '@ng-icons/core';
import {
  lucideBookMarked,
  lucideComponent,
  lucideLandPlot,
  lucideLoaderCircle,
  lucideMapPin,
  lucideNotebookText,
  lucideSchool,
  lucideUserStar,
} from '@ng-icons/lucide';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmSidebarImports } from '@spartan-ng/helm/sidebar';

import { SidepanelService } from '@shared/components/sidepanel/sidepanel.service';
import { HlmSpinnerImports } from '@spartan-ng/helm/spinner';
import { CartographieStore } from '../../cartographie/store/cartographie.store';
import { HeaderDashboardComponent } from '../components/header-dashboard/header-dashboard.component';
import { SpinnerComponent } from '@shared/components/spinner/spinner.component';

@Component({
  selector: 'app-admin-layout',
  imports: [
    RouterOutlet,
    HlmSidebarImports,
    HlmIconImports,
    RouterModule,
    HeaderDashboardComponent,
    HlmSpinnerImports,
    SpinnerComponent,
  ],
  templateUrl: './admin-layout.component.html',
  providers: [
    provideIcons({
      lucideComponent,
      lucideUserStar,
      lucideNotebookText,
      lucideBookMarked,
      lucideLandPlot,
      lucideSchool,
      lucideMapPin,
      lucideLoaderCircle,
    }),
  ],
})
export class AdminLayoutComponent implements OnInit {
  readonly #cartographieStore = inject(CartographieStore);
  readonly sidepanelService = inject(SidepanelService);
  ngOnInit() {
    this.#cartographieStore.charger();
  }
}
